import React from "react";
import NumberFormat from "react-number-format";

export default function NumberField(props) {
  return <NumberFormat {...props} />;
}
